<template>
    <Modal modalWidth="800px" class="" @close="closeModal">
        <template #modalHeader>
            <h2>{{ title }}</h2>
        </template>
        <template #modalBody>
            <div class="modal-body">
                <p>{{ message }}</p>
            </div>
        </template>
        <template #modalFooter>
            <button class="btn-add self-end" type="button" @click="closeModal">chiudi</button>
        </template>
    </Modal>
</template>

<script setup>
import Modal from '../lib/Modal.vue';

// eslint-disable-next-line no-unused-vars
const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    message: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['close']);

const closeModal = () => {
    emit('close');
};
</script>

<style lang="postcss" scoped>
.modal-body {
    height: auto;
}
</style>
